import { MONTHS } from "@/lib/services";
import { ServiceRow } from "@/components/app/ServiceRow";

const groupByMonth = (items) => {
  const groups = {};
  items.forEach((s) => { (groups[s.execution_date.slice(0, 7)] ||= []).push(s); });
  return Object.entries(groups);
};

export const ServiceList = ({ title, items, empty, testid, grouped = false }) => {
  if (!items) return null;
  return (
    <section data-testid={testid}>
      {title && <h2 className="mb-4 font-display text-lg font-bold tracking-tight">{title} <span className="font-mono text-sm text-slate-500">({items.length})</span></h2>}
      {items.length === 0 && <p className="rounded-xl border border-dashed border-slate-700 py-12 text-center text-sm text-slate-500" data-testid={`${testid}-empty`}>{empty}</p>}
      {grouped ? (
        <div className="space-y-6">
          {groupByMonth(items).map(([key, list]) => (
            <div key={key}>
              <div className="mb-2 text-xs font-semibold uppercase tracking-wider text-slate-400">{MONTHS[Number(key.slice(5, 7)) - 1]} {key.slice(0, 4)}</div>
              <div className="grid gap-3 lg:grid-cols-2">{list.map((s) => <ServiceRow key={s.id} s={s} />)}</div>
            </div>
          ))}
        </div>
      ) : (
        <div className="grid gap-3 lg:grid-cols-2">{items.map((s) => <ServiceRow key={s.id} s={s} />)}</div>
      )}
    </section>
  );
};
